import * as actionTypes from "../actions/actionTypes";

const tasks = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_COMMUNITY_FORM:
      return { ...state, getCommunityTaskForm: action.payload };
    case actionTypes.GET_EDIT_TASK_FORM:
      return { ...state, getEditDataTaskForm: action.payload };
    case actionTypes.GET_TASKS_WITH_PROCEDURES:
      return { ...state, getAllTasksWithProcedures: action.payload };
    case actionTypes.GET_TASKS_COUNT:
      return { ...state, getAllTasksCount: action.payload };
    case actionTypes.GET_TASK_DETAILS:
      return { ...state, getTaskDetails: action.payload };
    case actionTypes.GET_SUB_TASK_DETAILS:
      return { ...state, getSubTasksDetails: action.payload };
    case actionTypes.GET_ALL_TASK_ATTACHMENTS:
      return { ...state, getAllTaskAttachments: action.payload };
    case actionTypes.GET_ALL_SUB_TASK_ATTACHMENTS:
      return { ...state, getAllSubTaskAttachments: action.payload };
    case actionTypes.SEARCHKEY:
      return { ...state, searchkey: action.payload };
    case actionTypes.GET_SUB_TASK_FORM:
      return { ...state, getCommunitySubTaskForm: action.payload };

    default:
      return state;
  }
};

export default tasks;
